/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter {
    ProductID?: string;
    ProductName?: string;
    /**
     * 1 = NotArchived, 2 = Archived, 3 = Active
     */
    ProductState?: Open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter.ProductStateEnum;
    Limit?: number;
    Offset?: number;
    SortColumn?: string;
    /**
     * 0 = Ascending, 1 = Descending
     */
    SortOrder?: Open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter.SortOrderEnum;
}
export namespace Open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter {
    export type ProductStateEnum = 1 | 2 | 3;
    export const ProductStateEnum = {
        NUMBER_1: 1 as ProductStateEnum,
        NUMBER_2: 2 as ProductStateEnum,
        NUMBER_3: 3 as ProductStateEnum
    }
    export type SortOrderEnum = 0 | 1;
    export const SortOrderEnum = {
        NUMBER_0: 0 as SortOrderEnum,
        NUMBER_1: 1 as SortOrderEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter.ts